const Loader = () => {
    return (
        <div className="mb-6">
            <div className="page-loader">
                <div className="ui-loading">
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
export default Loader;